<template>
  <el-drawer
    title="Detalle de las Recargas"
    :visible.sync="showDrawerRecarga"
    :before-close="beforeClose"
    :modal="false"
    size="75%"
  >
    <el-card class="card">
      <div>
        <el-row
          class="flex-container-balance"
          style="padding-bottom: 0px; margin-bottom: 0px"
        >
          <el-button
            v-show="!loading_Balance_Data"
            type="primary"
            icon="el-icon-download"
            @click="exportReport"
            >Exportar</el-button
          >
          <el-col :span="10" :offset="1">
            <h2>
              Total:
              {{ $options.formatMonto(total) }}
              <i class="el-icon-coin"></i>
            </h2>
          </el-col>
          <!--<el-col :span="2" :offset="1">
            <h2>Cliente:</h2>
          </el-col>
          <el-col :span="10">
            <h2>
              <strong
                ><b>{{ CurrentClienData.clientName }}</b></strong
              >
            </h2>
          </el-col>-->
        </el-row>
      </div>
      <div>
        <el-row
          class="flex-container-balance"
          style="padding-bottom: 0px; margin-bottom: 0px"
        >
          <el-col :span="12"> </el-col>
          <el-col :span="12">
            <el-row :gutter="20" type="flex" justify="end">
              <el-col :span="6" :offset="1">
                <!--<h4>filtro diferencias</h4>-->
              </el-col>
              <rabbey-toolbox
                filter-placeholder="Buscar por nombre"
                filterables
                @filter-search="search = $event"
              />
            </el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <rabbey-table3
            :height="600"
            style="overflow: auto"
            ref="customerTable"
            :columns="RecargaTotalReportDetailledColumns"
            v-loading="loading_Balance_Data"
            :search="search"
            :border="true"
            :stripe="true"
            :data="FilteredData"
            :show-summary="true"
            :summary-method="getSummaries"
          />
        </el-row>
      </div>
    </el-card>
  </el-drawer>
</template>

<script>
import {
  RecargaTotalReportDetailledColumns
  //ClientsBalanceDetailledActions
} from "@/views/apps/ncfmovil/columnsTables/BalanceReportColumns.js";
import { formatMonto } from "@/utils";
import { exportExcel } from "@/helpers/exportExcel";
import { Decimal } from "decimal.js";

export default {
  formatMonto,
  name: "RecargaTotalReportDetailledColumns",
  props: {
    showDrawerRecarga: {
      type: Boolean,
      default: false
    },
    CurrentClienData: {
      type: Object,
      default: () => {}
    },
    ClientID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      RecargaTotalReportDetailledColumns,
      //ClientsBalanceDetailledActions,
      SupplierBalanceDataDetail: [],
      loading_Balance_Data: false,
      search: "",
      ClientSelected: "",
      CardHolderFiltered: [],
      FilteredData: [],
      total: 0.0
    };
  },
  mounted() {
    //console.log("this.CurrentClienData: ", this.CurrentClienData)
    this.GetRechargeReportDetailData(this.ClientID);
  },
  computed: {
    dataClients() {
      //console.log("SupplierBalanceDataDetail: ", this.SupplierBalanceDataDetail)
      let ClientsData = this.SupplierBalanceDataDetail.map((BalanceDetail) => {
        return {
          cardHolderId: BalanceDetail.cardHolderId,
          cardHolderName: BalanceDetail.cardHolderName
        };
      });
      //console.log("ClientsData: ", ClientsData)
      return ClientsData;
    }
  },
  methods: {
    async exportReport() {
      await exportExcel(
        RecargaTotalReportDetailledColumns.map((column) => {
          return column.label;
        }),

        this.FilteredData.map((data) => {
          return [
            data.fecha,
            data.Tipo,
            data.concepto,
            data.monto,
            data.status,
            data.Proveedor
          ];
        }),
        "Recarga Reporte"
      );
    },
    async GetRechargeReportDetailData(ClienID = null) {
      //console.log("GetBalanceReportDetailData: ","C ", ClienId, "S ", SuplierId )
      this.loading_Balance_Data = true;
      await this.$http
        .get(`/api/tennos/GetRechargeReportDetail?clienteID=${ClienID}`)
        .then((resp) => {
          this.FilteredData = resp.data;
          let total = new Decimal(0.0);
          resp.data.forEach((x) => {
            total = total.plus(x.monto);
          });
          this.total = total.toNumber();
          /*
            this.SupplierBalanceDataDetail.forEach((cardHolder) => {
              cardHolder.OpenDetail = this.OpenDetail;
            });
            */
          /*
            console.log(
              "SupplierBalanceDataDetail: ",
              this.SupplierBalanceDataDetail
            );
            */
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading_Balance_Data = false;
        });
      //console.log("Master Report: ", await this.SupplierBalanceDataMaster)
    },
    beforeClose() {
      this.$emit("OncloseDetail");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 1) {
          return;
        }
        if (index === 1) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    onCardHolderChanging(CardHolderId) {
      //console.log("CardHolderId: ", CardHolderId)
      //console.log("SupplierBalanceDataDetail: ", this.SupplierBalanceDataDetail)

      if (!CardHolderId) {
        this.FilteredData = this.CardHolderFiltered =
          this.SupplierBalanceDataDetail;
      } else {
        this.FilteredData = this.CardHolderFiltered =
          this.SupplierBalanceDataDetail.filter(
            (balanceData) => balanceData.cardHolderId === CardHolderId
          );
        //console.log("CardHolderFiltered: ", this.CardHolderFiltered)
      }
    }
    /*async onDiffChanging(concept) {
      switch (concept) {
        case "All": {
          this.FilteredData = this.SupplierBalanceDataDetail;
          break;
        }
        case "Diff": {
          this.FilteredData = this.SupplierBalanceDataDetail.filter(
            (balanceData) => balanceData.balanceDiff !== 0
          );
          break;
        }
        case "NoTDiff": {
          this.FilteredData = this.SupplierBalanceDataDetail.filter(
            (balanceData) => balanceData.balanceDiff === 0
          );
          break;
        }
        default: {
          break;
        }
      }
    }*/
  }
};
</script>

<style lang="css" scoped>
.flex-container-balance {
  display: flex;
  /*height: 200px;*/
  align-items: center;
}

.supliers_select {
  min-width: 60%;
}

.card {
  margin: 10;
}
</style>
